import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SidebarToggleProperties {
  isSideNavOpen: boolean;
  isSecondarySideNavOpen: boolean;
  isActiveSecondarySideNav: boolean;
}

export interface LargeSidebarState {
  sidebarToggleProperties: SidebarToggleProperties;
}

const initialState: LargeSidebarState = {
  sidebarToggleProperties: {
    isSideNavOpen: true,
    isSecondarySideNavOpen: false,
    isActiveSecondarySideNav: false,
  },
};

const largeSidebarSlice = createSlice({
  name: 'largeSidebar',
  initialState,
  reducers: {
    changeSidebarProperties: (state) => {
      state.sidebarToggleProperties.isSideNavOpen = !state.sidebarToggleProperties.isSideNavOpen;
    },
    changeSecondarySidebarProperties: (state) => {
      const next = !state.sidebarToggleProperties.isSecondarySideNavOpen;
      state.sidebarToggleProperties.isSecondarySideNavOpen = next;
      state.sidebarToggleProperties.isActiveSecondarySideNav = next;
    },
    changeSecondarySidebarPropertiesViaMenuItem: (state, action: PayloadAction<boolean>) => {
      state.sidebarToggleProperties.isSecondarySideNavOpen = action.payload;
      state.sidebarToggleProperties.isActiveSecondarySideNav = action.payload;
    },
    changeSecondarySidebarPropertiesViaOverlay: (state) => {
      const next = !state.sidebarToggleProperties.isSecondarySideNavOpen;
      state.sidebarToggleProperties.isSecondarySideNavOpen = next;
      // Keep the panel/highlight invariant: the overlay cannot flip the panel
      // without updating the active menu flag, or the two drift out of sync.
      state.sidebarToggleProperties.isActiveSecondarySideNav = next;
    },
  },
});

export const {
  changeSidebarProperties,
  changeSecondarySidebarProperties,
  changeSecondarySidebarPropertiesViaMenuItem,
  changeSecondarySidebarPropertiesViaOverlay,
} = largeSidebarSlice.actions;

export const selectSidebarToggleProperties = (state: any) => state.largeSidebar.sidebarToggleProperties;
export const selectIsSideNavOpen = (state: any) => state.largeSidebar.sidebarToggleProperties.isSideNavOpen;
export const selectIsSecondarySideNavOpen = (state: any) => state.largeSidebar.sidebarToggleProperties.isSecondarySideNavOpen;
export const selectIsActiveSecondarySideNav = (state: any) => state.largeSidebar.sidebarToggleProperties.isActiveSecondarySideNav;

export default largeSidebarSlice.reducer;
